export interface Business {
  aliases?: string[];
  businessTypes: number[];
  code?: string;
  createdBy?: string;
  createdDate?: string;
  id?: string;
  leadAssociateUserName?: string;
  lotNumbers?: string[];
  modifiedBy?: string;
  modifiedDate?: string;
  name: string;
}

export enum BusinessEntityType {
  Provider,
  Client,
  Manufacturer,
  Consignee,
  Brand,
  InternalCompany,
}

export interface BusinessSearch {
  name?: string;
  code?: string;
  businessTypes?: BusinessEntityType[];
}
